import logo from '../assets/logo.svg'
import { Link } from "react-router-dom";
import authProvider from "../authProvider";
import { useState } from "react";
import SpinnerButton from "../components/SpinnerButton.jsx";

export default function ForgotPassword() {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (event) => {
    setLoading(true);
    setError(null);
    event.preventDefault()
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries((formData).entries());
    const { success, error } = await authProvider.forgotPassword({ email: formJson.email });
    if (!success || error) {
      if (error) {
        setError(error.toString())
      } else {
        setError("Error sending password reset email.")
      }
      return
    }
    setSuccess(true);
  }

  if (success) {
    return (
      <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img
            alt="Fungistics Logo"
            src={logo}
            className="mx-auto h-10 w-auto"
          />
          <h2 className="mt-6 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
            Success
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
          <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
            <div className="text-gray-700 text-md font-bold tracking-tight ">
              Check your email for a link to reset your password.
            </div>
            <div className="text-gray-500 text-base mt-4">
              {`If you don't see the email, check your spam folder.`}
            </div>
          </div>

          <p className="mt-10 text-center text-sm/6 text-gray-500">
            Need help?{' '}
            <a href="/contact" className="font-semibold text-sky-800 hover:text-sky-600">
              Contact us here
            </a>
          </p>
        </div>


      </div>
    )
  }

  return (
    <>
      <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img
            alt="Fungistics Logo"
            src={logo}
            className="mx-auto h-10 w-auto"
          />
          <h2 className="mt-6 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
            Reset Your Fungistics Password
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
          <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                  Email address
                </label>
                <div className="mt-2">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    autoComplete="email"
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-sky-800 sm:text-sm/6"
                  />
                </div>
              </div>

              {error &&
                <div className='mt-4 text-red-500'>{error}</div>
              }

              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className={`flex w-full justify-center items-center rounded-md px-3 py-1.5 text-sm/6 font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${loading
                    ? "bg-sky-600 text-gray-200 cursor-not-allowed"
                    : "bg-sky-800 text-white hover:bg-sky-600 focus-visible:outline-sky-800"
                    }`}
                >
                  {loading ? (
                    <SpinnerButton />
                  ) : (
                    "Reset Password"
                  )}
                </button>

              </div>
            </form>

          </div>

          <p className="mt-10 text-center text-sm/6 text-gray-500">
            No account?{' '}
            <Link to="/register" className="font-semibold text-sky-800 hover:text-sky-600">
              Sign up for free.
            </Link>
          </p>
        </div>
      </div>
    </>
  )
}

